"use client";

import { FetchCardsDataResult, FetchCardsFilters } from "./type";
import { logger } from "@utilities/logger";

export async function fetchCardsClient(
  locale: string,
  page: number,
  filters?: FetchCardsFilters,
): Promise<FetchCardsDataResult> {
  const params = new URLSearchParams({
    locale,
    page: page.toString(),
  });
  if (filters?.categoryId) {
    params.set("categoryId", filters.categoryId);
  }
  if (filters?.industryIds && filters.industryIds.length > 0) {
    params.set("industryIds", filters.industryIds.join(","));
  }
  if (filters?.pinnedArticleIds && filters.pinnedArticleIds.length > 0) {
    params.set("pinnedArticleIds", filters.pinnedArticleIds.join(","));
  }

  let data: FetchCardsDataResult;
  try {
    const response = await fetch(`/next/api/customer-stories?${params.toString()}`);
    data = await response.json();
  } catch (error) {
    logger.error(error instanceof Error ? error : null, "Error fetching customer stories");
    return {
      cards: [],
      hasMore: false,
      totalPages: 1,
    };
  }

  return data;
}
